import script from "./CardModel.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardModel.vue?vue&type=script&setup=true&lang=ts"

import "./CardModel.vue?vue&type=style&index=0&id=68620bac&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68620bac"]])

export default __exports__